<template>
    <div class="container-fluid bg-dark px-5 d-none d-lg-block" style="background-color: #005c95 !important;">
        <div class="row gx-0 align-items-center" style="height: 45px;">
            <div class="col-lg-8 text-center text-lg-start mb-lg-0">
                <div class="d-flex flex-wrap">
                    <a href="#" class="text-light me-4">FMNJP (FLOOD MANAGEMENT IN NORTH JAVA PROJECT)</a>
                </div>
            </div>
            <div class="col-lg-4 text-center text-lg-end">
                <div class="d-flex align-items-center justify-content-end">
                    <a href="#" class="btn nav-fill me-6 text-white">Bahasa / Language</a>
                    <a href="#" class="btn btn-light btn-square border rounded-circle nav-fill me-3"
                        :class="[((bahasa === null) || (bahasa == 'ina') ? 'btn-pmis' : '')]"
                        @click="gantibahasa('ina')"><img src="../../../../../src/assets/img/ina.jpg" height="20"></a>
                    <a href="#" class="btn btn-light btn-square border rounded-circle nav-fill me-3"
                        :class="[((bahasa == 'eng') ? 'btn-pmis' : '')]" @click="gantibahasa('eng')"><img
                            src="../../../../../src/assets/img/eng.jpg" height="20"></a>
                </div>
            </div>
        </div>
    </div>
    <!-- Topbar End -->
    <div class="container-fluid position-relative p-0">
        <nav class="navbar navbar-expand-lg navbar-light bg-white px-4 px-lg-5 py-3 py-lg-0"
            style="border-top: solid 5px #005c95;">
            <a href="/" class="navbar-brand p-0">
                <h5 class="text-danger m-0 pmisdanger"><img src="../../../../../src/assets/img/nufrepr2.png"
                        height="100"></h5>
                <!-- <img src="img/logo.png" alt="Logo"> -->
            </a>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                <span class="fa fa-bars"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarCollapse">
                <div class="navbar-nav ms-auto py-0">
                    <a href="/"
                        :class="[((route.name == 'Beranda') ? 'nav-item nav-link active' : 'nav-item nav-link')]">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">BERANDA</span>
                        <span v-else>HOME</span>
                    </a>
                    <div class="nav-item dropdown">
                        <a href="#" data-bs-toggle="dropdown"
                            :class="[(((route.name == 'DaftarKonten')) ? 'nav-link active dropdown-toggle' : 'nav-link dropdown-toggle')]">
                            <span v-if="(bahasa === null) || (bahasa == 'ina')">PROFIL FMNJP</span>
                            <span v-else>FMNJP PROFILE</span>
                        </a>
                        <div class="dropdown-menu m-0">
                            <a :href="'/DaftarKonten/' + bytes1"
                                :class="[((route.name == 'DaftarKonten' && secretencData == '10') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Tentang FMNJP</span>
                                <span v-else>About FMNJP </span>
                            </a>
                            <a :href="'/DaftarKonten/' + bytes2"
                                :class="[((route.name == 'DaftarKonten' && secretencData == '11') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Unit Kerja / Balai / PIU</span>
                                <span v-else>Implementing Unit</span>
                            </a>
                            <a :href="'/DaftarKonten/' + bytes3"
                                :class="[((route.name == 'DaftarKonten' && secretencData == '12') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Tim Pelaksana FMNJP</span>
                                <span v-else>FMNJP Implementation Team</span>
                            </a>
                        </div>
                    </div>
                    <div class="nav-item dropdown">
                        <a href="#" data-bs-toggle="dropdown"
                            :class="[(((route.name == 'DaftarKegiatan') || (route.name == 'DaftarProgramBudgeting')
                                || (route.name == 'DaftarFinance') || (route.name == 'DaftarMonev') || (route.name == 'DaftarPDOIOS')
                                || (route.name == 'DaftarQuickStatus') || (route.name == 'DaftarGESIAP') 
                                || (route.name == 'DaftarStatus') || (route.name == 'DaftarEnvironmental') || (route.name == 'DaftarSocial')) ? 'nav-link active dropdown-toggle' : 'nav-link dropdown-toggle')]">
                            MONITORING
                        </a>
                        <div class="dropdown-menu m-0">
                            <a :href="'/DaftarStatus'"
                                :class="[((route.name == 'DaftarStatus') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Quick Status</span>
                                <span v-else>Quick Status</span>
                            </a>
                            <a :href="'/DaftarKegiatan'" style="display: none;"
                                :class="[((route.name == 'DaftarKegiatan') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">KEGIATAN UMUM</span>
                                <span v-else>GENERAL ACTIVITIES</span>
                            </a>
                            <a :href="'/DaftarProgramBudgeting'"
                                :class="[((route.name == 'DaftarProgramBudgeting') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Program & Budgeting</span>
                                <span v-else>Program & Budgeting</span>
                            </a>
                            <a :href="'/DaftarFinance'"
                                :class="[((route.name == 'DaftarFinance') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Keuangan</span>
                                <span v-else>Finance</span>
                            </a>
                            <a :href="'/DaftarQuickStatus'"
                                :class="[((route.name == 'DaftarQuickStatus') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Status Pengadaan</span>
                                <span v-else>Procurement Status</span>
                            </a>
                            <a :href="'/DaftarMonev'"
                                :class="[((route.name == 'DaftarMonev') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Progres Kegiatan Proyek</span>
                                <span v-else> Progress Of Project Package</span>
                            </a>
                            <a :href="'/DaftarEnvironmental'"
                                :class="[((route.name == 'DaftarEnvironmental') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Environmental Safeguard</span>
                                <span v-else>Environmental Safeguard</span>
                            </a>
                            <a :href="'/DaftarSocial'"
                                :class="[((route.name == 'DaftarSocial') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Social Safeguard</span>
                                <span v-else>Social Safeguard</span>
                            </a>
                            <a :href="'/DaftarGESIAP'"
                                :class="[((route.name == 'DaftarGESIAP') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Gender Equality And Social Inclusion
                                    Action Plan</span>
                                <span v-else>Gender Equality And Social Inclusion Action Plan</span>
                            </a>
                            <a :href="'/DaftarPDOIOS'"
                                :class="[((route.name == 'DaftarPDOIOS') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Result Framework Progress</span>
                                <span v-else>Result Framework Progress</span>
                            </a>
                            
                        </div>
                    </div>
                    <div class="nav-item dropdown">
                        <a href="#" data-bs-toggle="dropdown"
                            :class="[(((route.name == 'Aduan') || (route.name == 'CariAduan')
                                || (route.name == 'DaftarAduan')) ? 'nav-link active dropdown-toggle' : 'nav-link dropdown-toggle')]">
                            <span v-if="(bahasa === null) || (bahasa == 'ina')">LAYANAN ADUAN</span>
                            <span v-else>COMPLAINTS SERVICE</span>
                        </a>
                        <div class="dropdown-menu m-0">
                            <a :href="'/Aduan'"
                                :class="[((route.name == 'Aduan') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Input Layanan Pengaduan</span>
                                <span v-else>Complaint Services Input</span>
                            </a>
                            <a :href="'/CariAduan'"
                                :class="[((route.name == 'CariAduan') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Cari Pengaduan</span>
                                <span v-else>Find Complaint</span>
                            </a>
                            <a :href="'/DaftarAduan'"
                                :class="[((route.name == 'DaftarAduan') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Monitoring Pengaduan</span>
                                <span v-else>Complaint Monitoring</span>
                            </a>
                        </div>
                    </div>
                    <a :href="'/GIS/' + bytes"
                        :class="[((route.name == 'GIS') ? 'nav-item nav-link active' : 'nav-item nav-link')]">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">PETA</span>
                        <span v-else>MAPS</span>
                    </a>
                    <div class="nav-item dropdown">
                        <a href="#" data-bs-toggle="dropdown"
                            :class="[(((route.name == 'DaftarBerita') || (route.name == 'DaftarAlbumDokumen')
                                || (route.name == 'DaftarAlbum')) ? 'nav-link active dropdown-toggle' : 'nav-link dropdown-toggle')]">
                            <span v-if="(bahasa === null) || (bahasa == 'ina')">PRODUK</span>
                            <span v-else>PRODUCT</span>
                        </a>
                        <div class="dropdown-menu m-0">
                            <a :href="'/DaftarBerita'"
                                :class="[((route.name == 'DaftarBerita') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Berita</span>
                                <span v-else>News</span>
                            </a>
                            <a :href="'/DaftarAlbumDokumen'"
                                :class="[((route.name == 'DaftarAlbumDokumen') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Dokumen</span>
                                <span v-else>Documents</span>
                            </a>
                            <a :href="'/DaftarAlbum'"
                                :class="[((route.name == 'DaftarAlbum') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Galeri</span>
                                <span v-else>Gallery</span>
                            </a>
                        </div>
                    </div>
                    <div class="nav-item dropdown">
                        <a href="#" data-bs-toggle="dropdown"
                            :class="[(((route.name == 'KontakKami') || (route.name == 'FAQ') || (route.name == 'MasukanSaran')) ? 'nav-link active dropdown-toggle' : 'nav-link dropdown-toggle')]">
                            <span v-if="(bahasa === null) || (bahasa == 'ina')">KONTAK KAMI</span>
                            <span v-else>CONTACT US</span>
                        </a>
                        <div class="dropdown-menu m-0">
                            <a :href="'/KontakKami'"
                                :class="[((route.name == 'KontakKami') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')"> Kontak Kami</span>
                                <span v-else>Contact Us</span>
                            </a>
                            <a :href="'/FAQ'"
                                :class="[((route.name == 'FAQ') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">FAQ</span>
                                <span v-else>FAQ</span>
                            </a>
                            <a :href="'/MasukanSaran'"
                                :class="[((route.name == 'MasukanSaran') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Saran Dan Masukan</span>
                                <span v-else>Suggestions And Feedback</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    </div>
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';

export default {
    setup() {
        const route = useRoute()
        watch(() => route.name, () => {
        });

        return { route };
    },
    components: {
        swal
    },
    data() {
        return {
            tabaktif: encodeURIComponent(CryptoJS.AES.encrypt('', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString()),
            tahun: new Date().getFullYear(),
            bahasa: localStorage.getItem("bahasasistem"),
            bytes: encodeURIComponent(CryptoJS.AES.encrypt('Kosong', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString()),
            bytes1: encodeURIComponent(CryptoJS.AES.encrypt('10', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString()),
            bytes2: encodeURIComponent(CryptoJS.AES.encrypt('11', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString()),
            bytes3: encodeURIComponent(CryptoJS.AES.encrypt('12', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString()),

            secretencData: '',
        };
    },
    methods: {
        gantibahasa(bahasanya) {
            localStorage.setItem("bahasasistem", bahasanya);
            location.reload();
        },
    },
    mounted() {
        try {
            this.secretencData = decodeURIComponent(CryptoJS.AES.decrypt(this.route.params.id, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString(CryptoJS.enc.Utf8));
        } catch (error) {
        }
    },
}
</script>

<style></style>